<div class="container  no-padding min-height-100">
    <div class="d-flex justify-content-center mt-5  mb-5">
        <div class="row col-12 d-flex justify-content-center mt-3 no-padding">
            <div class="col-12 col-lg-11 col-xl-10 row d-flex justify-content-center no-padding "
                style="color: #000000;">

            </div>
            <div class="col-12 col-lg-11 col-xl-10 row d-flex justify-content-center mt-2">

                <div class="col-12 col-md-12 d-flex justify-content-center mb-2">
                    <div class="col-8 col-md-3">
                        <img src="../../../assets/texts/events-and-products.svg" style="width: 100%" alt="">
                    </div>

                </div>

                <app-spinner-loading *ngIf="loading"></app-spinner-loading>

                <app-div-no-result *ngIf="!menus.length && !loading"></app-div-no-result>

                <div *ngFor="let event of menus" class="col-12 col-sm-6 col-md-6 col-lg-4 mt-2 mb-2">



                    <div class="card">
                        <div class="card-top">
                            <img [src]="event.image" alt="Blog Name">
                        </div>
                        <div class="card-info" style="  padding: 0px 20px;">
                            <h2 class="text-truncate text-center">{{event.name}}</h2>
                            <span class="date text-center">{{event.dateStart | date : 'dd/MM/yyyy, h:mm a' :
                                'GMT'}}</span>
                            <!-- <p class="excerpt">{{event.desc}}</p> -->
                        </div>
                        <div class="mb-2 flex-row  d-flex justify-content-center" style="  padding: 0px 20px;">
                            <div class="col-12  d-flex justify-content-center  align-items-center row ">

                                <button class="col-12" routerLink="/menus/{{event.menu.id}}" mat-raised-button
                                    color="primary">
                                    <mat-icon>local_bar</mat-icon> VER CARTA ({{event.menu.products.length}})
                                </button>


                            </div>
                        </div>

                        <div class="card-footer text-muted text-center">
                            <div class="d-flex justify-content-center  align-items-center">
                                <mat-icon>location_on</mat-icon>
                                <a style="text-decoration: none;color:unset"
                                    href="https://www.google.cl/maps/search/{{event.address}}" target="_blank">
                                    <h5 style="margin-bottom: 0px;" class="text-truncate-2-line">{{event.address}}</h5>

                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- <app-card-menu [menu]="menu">
                    </app-card-menu> -->
                </div>
            </div>
        </div>
    </div>
</div>